<template>
	<Card>
		<div class="campaign">
			<h2 class="campaign__title">{{ campaign.name }}</h2>
			<div class="campaign__actions">
				<Action v-if="showView" title="View campaign" @click="view">
					<IconView />
				</Action>
				<Action v-if="showEdit" title="Edit campaign" @click="edit">
					<IconEdit />
				</Action>
				<Action v-if="showAdd" title="Add submission" @click="add">
					<IconAdd />
				</Action>
				<DownloadButton v-if="showDownload" :id="campaign.id" />
			</div>
		</div>
	</Card>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from '@/components/shared/Card'
import Action from '@/components/shared/Action'
import DownloadButton from '@/components/admin/DownloadButton'
import IconView from 'mdi-vue/Eye'
import IconEdit from 'mdi-vue/Pencil'
import IconAdd from 'mdi-vue/PlusBox'

const ACTIONS = ['view', 'edit', 'add', 'download']

export default {
	name: 'campaign',
	props: {
		campaign: Object,
		hide: {
			type: Array,
			default: () => [],
			validator: v => v.every(i => ACTIONS.includes(i))
		}
	},
	computed: {
		...mapGetters({ isAdmin: 'auth/isAdmin' }),
		showActivate() {
			return !this.hide.includes('activate')
		},
		showView() {
			return !this.hide.includes('view')
		},
		showEdit() {
			// Only admins can edit campaigns
			return !this.hide.includes('edit') && this.isAdmin
		},
		showAdd() {
			return !this.hide.includes('add')
		},
		showDownload() {
			return !this.hide.includes('download')
		}
	},
	methods: {
		navigate(name) {
			const params = { id: this.campaign.id }
			this.$router.push({ name, params })
		},
		view() {
			this.navigate(this.active ? 'Current Campaign' : 'View Campaign')
		},
		edit() {
			this.navigate('Edit Campaign')
		},
		add() {
			this.navigate('Add Submission')
		}
	},
	components: {
		Card,
		Action,
		DownloadButton,
		IconView,
		IconEdit,
		IconAdd
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';
@import '~scss/components';

.campaign {
	@extend %flex-row;
	width: 100%;
	justify-content: space-between;

	&__title {
		margin: 0;
	}

	&__actions {
		&,
		button {
			color: $black;
		}
	}
}
</style>
